import { useTranslation } from "react-i18next";import React from 'react';
import { Badge } from '@/shared/components/ui/badge';
import { cn } from '@/shared/utils';

const statusConfig = {
  // Inventory statuses
  in_stock: { label: 'In Stock', variant: 'success', dot: 'bg-green-500' },
  low_stock: { label: 'Low Stock', variant: 'warning', dot: 'bg-amber-500' },
  out_of_stock: { label: 'Out of Stock', variant: 'destructive', dot: 'bg-red-500' },

  // Task statuses
  pending: { label: 'Pending', variant: 'secondary', dot: 'bg-slate-400' },
  in_progress: { label: 'In Progress', variant: 'info', dot: 'bg-blue-500' },
  completed: { label: 'Completed', variant: 'success', dot: 'bg-green-500' },
  quarantine: { label: 'Quarantine', variant: 'warning', dot: 'bg-amber-500' },
  issue: { label: 'Issue', variant: 'destructive', dot: 'bg-red-500' },

  // Order statuses
  ready_to_pick: { label: 'Ready to Pick', variant: 'info', dot: 'bg-blue-500' },
  picking: { label: 'Picking', variant: 'info', dot: 'bg-blue-500' },
  packing: { label: 'Packing', variant: 'secondary', dot: 'bg-purple-500' },
  staged: { label: 'Staged', variant: 'success', dot: 'bg-green-500' },
  shipped: { label: 'Shipped', variant: 'success', dot: 'bg-green-600' },

  // Verification statuses
  matched: { label: 'Matched', variant: 'success', dot: 'bg-green-500' },
  shortage: { label: 'Shortage', variant: 'destructive', dot: 'bg-red-500' },
  unexpected: { label: 'Unexpected', variant: 'warning', dot: 'bg-amber-500' },

  // Priority
  high: { label: 'High', variant: 'destructive', dot: 'bg-red-500' },
  medium: { label: 'Medium', variant: 'warning', dot: 'bg-amber-500' },
  low: { label: 'Low', variant: 'secondary', dot: 'bg-slate-400' }
};

const variantStyles = {
  success: 'bg-green-50 text-green-700 border-green-200 dark:bg-green-950 dark:text-green-400 dark:border-green-800',
  warning: 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-400 dark:border-amber-800',
  destructive: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-950 dark:text-red-400 dark:border-red-800',
  info: 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-400 dark:border-blue-800',
  secondary: 'bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700'
};

export const StatusIndicator = ({ status, showDot = true, className }) => {const { t } = useTranslation("wms");
  const config = statusConfig[status] || { label: status, variant: 'secondary', dot: 'bg-slate-400' };

  return (
    <Badge
      className={cn(
        "inline-flex items-center gap-1.5 font-medium border",
        variantStyles[config.variant],
        className
      )}>
      
      {showDot &&
      <span className={cn("h-1.5 w-1.5 rounded-full", config.dot)} />
      }
      {config.label}
    </Badge>);

};

export const PriorityBadge = ({ priority, className }) => {const { t } = useTranslation("wms");
  return <StatusIndicator status={priority} className={className} />;
};